import SimpleBar from 'simplebar';

export default class {

    constructor (element) {
        // console.log('new TeamProfileModal() called');
        if(!(element instanceof HTMLElement)) {
			throw new TypeError('Invalid element');
		}

        this.element = element;
        this.postId = this.element.dataset.postId;

        if (this.postId == false || this.postId === "") {
            console.warn('[TeamProfileModal] element does not contain postId');
            return;
        }

        this.element.addEventListener('click', (e) => this.openProfileModal(e));
    }

    openProfileModal(event) {
        event.preventDefault();

        // team card social icons open in new tab
        if (event.target.tagName == 'A' && event.target.href) {
            window.open(event.target.href,'_blank');
            return;
        }

        // make a requrest to get the post data
        let request = this._makeRequest(this.postId);

        request.then( response => {
            // console.log(response);

            if (response != null && response.length) {
                response.forEach( post => {

                    this.populateProfileModal(post);
                });
            }
        });
    }

    /**
     * Get team member data by id
     * 
     * Make a request to get a team memebers profile data
     * 
     * @param {*} postId 
     * @returns 
     */
    _makeRequest(postId) {
        // console.log('[TeamProfileModal] makeRequest() called');
        // console.log(`makeRequest for post ${postId}`);

		return fetch(`${window.wpRestApi.baseUrl}`, {
            method: 'POST',
            redirect: 'error',
            mode: 'cors',
            referrer: 'origin',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded; charset=utf-8'
            },
            body: `action=get_team_post&postId=${postId}`,
        }).then( response => {
            return response.json().then( json => {
                if (response.ok) {
                    // console.log(json);
                    return json;
				} else {
					let errors = {};

					if(json.exception || json.exception) {
						errors.server = [json.message || json.exception];
					}

					response.errors = json.errors || errors;

					console.error(response);

					return Promise.reject(response);
				}
            });
        });
    }

    /**
     * Populate and show the profile modal
     * 
     * @param {*} post 
     */
    populateProfileModal (post) {
        // console.log(post);

        let profileModal    = document.getElementById('modal-profile'),
            profileHeader   = profileModal.querySelector('.profile__header'),
            profileOverview = profileModal.querySelector('.profile__overview'),
            profileImage    = profileModal.querySelector('.profile__image');

        // console.log(post.post_title);
        // console.log(post.job_title);
        // console.log(post.department);
        // console.log(post.image_html);
        // console.log(post.post_content);

        // Set the profile header
        let profileHeaderText = `<h3 class="profile__name underline"><span>${post.post_title}</span></h3>`;

        if (typeof post.job_title !== 'undefined' && post.job_title.length) {
            profileHeaderText += `<p class="profile__position">${post.job_title}</p>`;
        }

        profileHeader.innerHTML = "";
        profileHeader.insertAdjacentHTML('afterbegin', profileHeaderText);

        // Set the profile overview
        if(typeof profileOverview.simplebar !== 'undefined'){
            profileOverview.simplebar.unMount();
        }

        profileOverview.innerHTML = "";

        if (post.post_content != false || post.post_content != "") {
            profileOverview.innerHTML = post.post_content;
        }

        profileOverview.simplebar = new SimpleBar(profileOverview, {
            direction: 'rtl',
            autoHide: true,
            // forceVisible: true,
        });


        // Set the profile image
        if (profileImage) {
            profileImage.remove();
        }
        profileModal.querySelector('.modal__container').insertAdjacentHTML('beforeend', post.image_html);

        // Open the profile modal
        MicroModal.show('modal-profile');
    }
}
